/**
 * Query keys for the code-connection surfaces. The connection-scoped keys
 * hang off `CODE_CONNECTIONS_KEY`, so invalidating the list (what a
 * `code.connections.changed` frame does) also refreshes an open sheet's
 * setup and usage reads.
 */

export const CODE_CONNECTIONS_KEY = ['code', 'connections'] as const
export const codeConnectionSetupKey = (id: string) => ['code', 'connections', id, 'setup'] as const
export const codeConnectionUsageKey = (id: string) => ['code', 'connections', id, 'usage'] as const

export const CODE_REPOSITORIES_ROOT = ['code', 'repositories'] as const
export const codeRepositoriesKey = (connectionId: string | null, q: string) =>
  ['code', 'repositories', connectionId ?? 'all', q] as const

export const projectRepositoriesKey = (projectId: string) =>
  ['project', projectId, 'repositories'] as const
